import React, { useEffect } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import AuthService from "./services/AuthService.ts";

const ProtectedRoute: React.FC = () => {
  const authService = AuthService.getInstance();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function isAuthenticated(){
      try {
        await authService.loadAppConfig();
        await authService.loadAzureConfig();
        await authService.initializeMsalClient();
        let token = await authService.getToken();
        if(!token){
          throw Error("Could not get token");
        }
      } catch {
        navigate("/login", { state: { from: location }, replace: true });
      }
    }
    isAuthenticated()
  }, [navigate, location, authService]);

  return <Outlet/>;
};

export default ProtectedRoute;
